import styled from 'styled-components'
import { media } from '../../GlobalStyle'

export const TabMenu = styled.div`
  background-color: #fff;
  width: fit-content;
  margin: 0 auto 20px;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: ${(props) => props.theme.border.radius || '6px'};
  overflow: hidden;
  box-shadow: 0px 3px 3px #00000024;
`

export const TabItem = styled.button`
  background-color: #e9e9e9;
  color: #212b36;
  outline: 0;
  padding: 1.125em;
  /* min-width: 33%; */
  line-height: 1;
  text-align: center;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
  border: 0;
  transition: all 0.2s ease-in-out;

  &:hover,
  &.active {
    background-color: ${(props) =>
      props.theme.button.secondary.hover || '#f1f5f8'};
    color: ${(props) => props.theme.button.secondary.textColor || '#212b36'};
  }

  ${media.medium} {
    padding: 1.125em 2em;
    min-width: 180px;
  }
`
